import { sportDontHaveImage } from 'api/mockSportCategory';
import Typo from 'consts/typography';
import { GameResponseModel } from 'models';
import { formatDateNoTime } from 'utils/dateUtils';
import { IMG_ALT } from 'consts/app';

interface GameScoreProps {
  game: GameResponseModel;
}
const GameScore: React.FC<GameScoreProps> = ({ game }) => {
  const renderScore = (gameScore: number | null, gameScoreString: string | null) => {
    if (gameScore !== null) {
      return <p>{gameScore}</p>;
    }

    if (gameScoreString !== null) {
      const [part1, part2] = gameScoreString.split(/ (?=\()/);
      return (
        <div className="addition-score">
          <p>{part1}</p>
          <p>{part2 || ''}</p>
        </div>
      );
    }

    return <p>--</p>;
  };

  return (
    <div className="game-container">
      <div className="category">
        <div className={`category-name ${Typo.p7}`}>
          <span className={Typo.p7}>{formatDateNoTime(game.startDate)}</span>
        </div>
      </div>
      <div className="game-score-detail">
        <div className="team-container homeTeam">
          <div className="team-detail homeTeam">
            <div className="teamName">{game.homeTeam}</div>
            {!sportDontHaveImage.includes(game.sport.group.toLowerCase()) && (
              <div className="team-image">
                <img
                  onError={(e) => {
                    e.currentTarget.src = '/defaultImage.png';
                  }}
                  src={game.homeTeamLogo}
                  alt={IMG_ALT}
                />
              </div>
            )}
          </div>
          <div className="score">
            {/* <p>{game.score?.scoreHomeTotal ?? game.score?.scoreHomeString ?? '--'}</p> */}
            {renderScore(game.score?.scoreHomeTotal, game.score?.scoreHomeString)}
          </div>
        </div>

        <div className="vs primary-text-color">-</div>

        <div className="team-container awayTeam">
          <div className="team-detail awayTeam">
            <div className="teamName">{game.awayTeam}</div>
            {!sportDontHaveImage.includes(game.sport.group.toLowerCase()) && (
              <div className="team-image">
                <img
                  onError={(e) => {
                    e.currentTarget.src = '/defaultImage.png';
                  }}
                  src={game.awayTeamLogo}
                  alt={IMG_ALT}
                />
              </div>
            )}
          </div>
          <div className="score">
            {/* <p>{game.score?.scoreAwayTotal ?? game.score?.scoreAwayString ?? '--'}</p> */}
            {renderScore(game.score?.scoreAwayTotal, game.score?.scoreAwayString)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameScore;
